import { ZOOM_CHANGED } from '../../constants';
import setShapes from './set-shapes';
const addZoomListener = (map, router, shapes, imageData, client) => {
  if (!map) return;
  setShapes(map, router, shapes, imageData);
  map.addListener(ZOOM_CHANGED, () => setShapes(map, router, shapes, imageData, client));
};
export default addZoomListener;
//# sourceMappingURL=add-zoom-listener.js.map